/**
 * ljy 2022-04-01
 */
import Vue from "vue";
import api from "@/api";

function ajax(url, data, method)
{
    if (method == 'get')
    {
        let params = data;
        return api.get(url);
    }

    return api.post(url, data);
}

function log(data, name)
{
    if (typeof data === 'number')
    {
        if (name) return console.log(name, data + '');
        return console.log(data + '');
    }
    else if (typeof data === 'object')
    {
        if (name) return console.log(name, data);
        return console.log(data);
    }
    else if (this.isJsonObj(data))
    {
        var json = JSON.stringify(data);
        if (name) return console.log(name, json);
        return console.log(json);
    }
    else
    {
        if (name) return console.log(name, data);
        return console.log(data);
    }
}

function isJsonObj(obj)
{
    if (typeof(obj) == "object" && (Object.prototype.toString.call(obj).toLowerCase() == "[object object]" || Object.prototype.toString.call(obj).toLowerCase() == "[object]"))
    {
        return true;
    }
    return false;
}

function isJsonStr(str)
{
    if (typeof str == 'string')
    {
        try
        {
            var obj = JSON.parse(str);
            if (typeof obj == 'object' && obj)
            {
                return true;
            }
            else
            {
                return false;
            }

        }
        catch (e)
        {
            return false;
        }
    }
    return false;
}

function message(message, type, dangerouslyUseHTMLString, customClass) {
    Vue.prototype.$message({
        showClose: true,
        message: message,
        type: type || 'success',
        dangerouslyUseHTMLString,
        customClass
    });
}

function alert(content, title, callback) {
    Vue.prototype.$alert(content, title, callback);
}

function confirm(content, title, callback1, callback2, confirmButtonText, cancelButtonText) {
    Vue.prototype.$confirm(content, title || '温馨提示', {
        confirmButtonText: confirmButtonText || '确定',
        cancelButtonText: cancelButtonText || '取消',
        closeOnClickModal: false,
        type: 'warning',
        lockScroll: false,
    }).then(() => {
        if (callback1) {
            callback1()
        }
    }).catch(() => {
        if (callback2) {
            callback2()
        }
    });
}

function notify(message, title, type, position) {
    Vue.prototype.$notify(message, title, type || 'success', position);
}

function loading(index, text) {
    Vue.prototype.$loading(index, text);
}

function getTimeFormat(day, second)
{
    day     = day + 1;
    second  = second || 0;
    const time   = new Date(new Date().setHours(0, 0, 0, 0) + 3600 * 1000 * 24 * day + second);
    return time;
}

/**
 * @description 表格高度
 * @param {*} formType
 */
Vue.prototype.$baseTableHeight = (formType) => {
    let height = window.innerHeight
    const paddingHeight = 291
    const formHeight = 60

    if ('number' === typeof formType) {
        height = height - paddingHeight - formHeight * formType
    } else {
        height = height - paddingHeight
    }
    return height
}

const ty = {
    ajax: ajax,
    log: log,
    isJsonObj: isJsonObj,
    isJsonStr: isJsonStr,
    message: message,
    alert: alert,
    confirm: confirm,
    notify: notify,
    loading: loading,
    getTimeFormat: getTimeFormat,
}
export default ty;
